/**
 * FantasyArchetype.js
 * Statistical targets for Fantasy music (Lydian, Magical, Adventure).
 * Traits: High Dynamic Swells, Sparkling Highs, Lydian Harmony.
 */

import { BASE_ARCHETYPE } from './BaseArchetype.js';

export const FANTASY_ARCHETYPE = {
    ...BASE_ARCHETYPE,

    // Voice Distribution: Balanced but "Sparkling" (High/Mid focus).
    // Unlike Cinematic (Bottom Heavy), Fantasy needs shimmering highs (Harp, Flute, Celesta).
    voiceDistribution: {
        ...BASE_ARCHETYPE.voiceDistribution,
        low: 0.25,
        mid: 0.40,
        high: 0.35,
        tolerance: 0.15,
        tuttiThreshold: 0.9
    },

    // Dynamic Range: Very High. Swells are critical.
    dynamicRange: {
        ...BASE_ARCHETYPE.dynamicRange,
        minVariance: 0.15,
        targetVariance: 0.25
    },

    // Harmonic Consonance: Lydian/Major implies high consonance.
    harmonicConsonance: {
        ...BASE_ARCHETYPE.harmonicConsonance,
        polarity: 'consonant'
    }
};
